<template>
  <section class="questions">
    <div class="grid" v-if="misc">
      <div class="cell help-info">
        <div class="help-heading">{{misc.questions_heading}}</div>
        <p>{{misc.paragraph}}</p>
        <ul>
          <li v-if="contact_info && contact_info.telephone_numbers && contact_info.telephone_numbers.length">
            <a :href="'tel:' + removeSpaces(contact_info.telephone_numbers[0].number)">
              <i class="fa fa-phone"></i>
              Call us on {{contact_info.telephone_numbers[0].number}} for free advice
            </a>
          </li>
          <li v-if="contact_page">
            <page-link :href="contact_page.url">
              <i class="fa fa-send"></i> Submit an online enquiry
            </page-link>
          </li>
          <li v-if="faqs_page">
            <page-link :href="faqs_page.url">
              <i class="fa fa-file-text"></i> Read our FAQs page
            </page-link>
          </li>
        </ul>
      </div>
      <div :style="'background-image:url('+ misc.questions_image +')'" class="cell help-img"></div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex"
import stringFormatter from "../utils/formatstring"
export default {
  name: "Questions",
  mixins: [stringFormatter],
  computed: {
    ...mapState(["misc", "contact_info", "contact_page", "faqs_page"])
  }
}
</script>

<style scoped>
.questions {
  margin-bottom: 0;
  line-height: 0;
  background: #434f50;
  font-size: 2rem;
}

.grid {
  display: table;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.cell {
  display: table-cell;
}

.help-info {
  padding: 6rem 5rem;
  color: white;
  line-height: 1.4;
}

.help-img {
  background-size: cover;
  background-position: center center;
}

.help-heading {
  font-size: 3rem;
  margin-bottom: 2rem;
  color: #f7912b;
}

.questions p {
  max-width: 700px;
  margin-bottom: 2rem;
}

.help-heading span {
  color: white;
}

.questions ul {
  list-style-type: none;
}

.questions li {
  margin-bottom: 1.5rem;
}

.questions i {
  width: 2rem;
  margin-right: 1rem;
  color: #f7912b;
}

@media screen and (max-width: 850px) {
  .help-info {
    padding: 3rem 3rem;
  }

  .grid {
    grid-template-columns: 1fr;
  }

  .help-img {
    display: block;
    height: 40rem;
  }
}
</style>
